export default "__VITE_ASSET__Bxl1HOqp__"